import BusinessApi from './BusinessApi';

export const fetchFooter = (token) => {
    return {
        type: 'FETCH_FOOTER',
        payload: BusinessApi.get(`/api/menu/footer`, {cancelToken: token})
    };
};